import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormControl, Validators, FormGroup } from '@angular/forms';
import { MessagesService } from '../messages/messages.service';
import { CarrierState } from '../masterdata/models/carrierState';
import { SelectableLab } from '../carrier/selectable-lab';
import { ErrorHandler } from '../utils/error-handler';
import { CarrierStatusService } from '../carrier-status/carrier-status.service';
import { ContainerMergeService } from '../container-merge/container-merge.service';
import { Printer } from '../masterdata/models/printer';
import { ProcessState } from '../masterdata/models/processState-enum';
import { LabProcessingRequest } from '../carrier-status/processing-request';

@Component({
  selector: 'app-step-thermal-cycling',
  templateUrl: './step-thermal-cycling.component.html',
  styleUrls: ['./step-thermal-cycling.component.css']
})
export class StepThermalCyclingComponent implements OnInit {

  thermalCyclingForm: FormGroup;

  thermalCreatedBy: string;
  thermalContainerBarcode: string;
  thermalMachineBarcode: string;

  //selectedStatus: CarrierState;
  selectedLab: SelectableLab;

  isReadyForSubmit: boolean;
  submitted: boolean;
  errorHandler: ErrorHandler = new ErrorHandler;

  blocked: boolean

  @Input() carrierStateDetails: CarrierState;
  @Input() printersList : Printer[];
  selectedPrinter : Printer;

  machineNotFoundError = {
    severity: 'error',
    summary: 'Invalid Machine Barcode',
    detail: "Machine does not exists in the System"
  }

  constructor(private formBuilder: FormBuilder,
    private _messagesService: MessagesService,
    private carrierStatusService: CarrierStatusService, private containerMergeService: ContainerMergeService) {
      this.selectedLab = JSON.parse(localStorage.getItem('lab'));
    }

    ngOnInit() {
      if(this.carrierStateDetails.printer && this.carrierStateDetails.printer.active)
      {
      this.selectedPrinter = this.carrierStateDetails.printer;
      }
      this.thermalCyclingForm = this.formBuilder.group({
        'thermalCreatedBy': new FormControl('', Validators.required),
        'thermalContainerBarcode': new FormControl('', Validators.required),
        'thermalMachineBarcode': new FormControl('', Validators.required),
        'thermalSelectedPrinter': new FormControl('', Validators.required)
      });
     //this.selectedStatus = { _id: 'nonMdmId', name: ProcessStep.THERMAL_CYCLER, lab: this.selectedLab.lab, active: true, printer : null, machineType : null};
    }


     /**
   * @function
   * @description: This method is to get the focus to Carrier Barcode Field
   */
  focusThermalContainerBarcode() {
    document.getElementById('thermalContainerBarcode').focus();
  }
  /**
   * @function
   * @description: This method is to get the focus to Machine Barcode Field
   */
  focusThermalMachineBarcode() {
    document.getElementById('thermalMachineBarcode').focus();
  }

  /**
   * @function
   * @description: This method is to add entry at start of the process of the Carrier State
   */
  start() {
    this.addCarrierStatus(ProcessState.STARTED)
  }
  /**
   * @function
   * @description: This method is to add entry at cancel of the process of the Carrier State
   */
  cancel() {
    this.addCarrierStatus(ProcessState.CANCELED)
  }

  /**
   * @function
   * @description: This method is to add entry at Complete of the process of the Carrier State
   */
  complete() {
    this.addCarrierStatus(ProcessState.COMPLETED)
  }

   /**
   * @function
   * @description: This method is to add Carrier status Details
   */
  addCarrierStatus(processState: ProcessState) {

    this.blocked = true
    let status = new LabProcessingRequest;
    status.createdBy = this.thermalCreatedBy;
    status.containerBarcode = this.thermalContainerBarcode.trim();
    this.carrierStateDetails.printer = this.selectedPrinter;
    status.machineBarcode = this.thermalMachineBarcode.trim();
    status.processState = processState;
    status.lab = this.selectedLab.lab
    status.carrierState = this.carrierStateDetails;
    status.machineType = this.carrierStateDetails.machineType;

    this.carrierStatusService.addCarrierStatus(status).subscribe(
      results => {
        if (processState == ProcessState.STARTED) {
          this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Process Started', detail: 'Thermal cycling started' });
        }
        else if (processState == ProcessState.CANCELED) {
          this._messagesService.addSuccessMessage({ severity: 'warning', summary: 'Process Cancelled', detail: 'Thermal cycling cancelled' });
        }
        else if (processState == ProcessState.COMPLETED) {
          this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Process Completed', detail: 'Thermal cycling completed' });
        }

        this.blocked = false
      },
      error => {
        if (error != null && error.error != null && error.error.bbApiError != null && error.error.bbApiError.errors != null) {
          this._messagesService.addErrorMessage({ severity: 'error', summary: error.error.bbApiError.title, detail:this.getSubErrors(error.error.bbApiError.errors) });
        }else{
          this._messagesService.addErrorMessage(this.errorHandler.handleError(error));
        }

        this.blocked = false
      }
    );
    if(processState == ProcessState.CANCELED || processState == ProcessState.COMPLETED){
      this.isReadyForSubmit = true;
    }
}
  // used to get all the sub errors in the single string
  getSubErrors(errors:any[]){
    var errorText : string =''
    for(var e = 0; e < errors.length; e++){
      errorText += errors[e].message;
      if(e != errors.length - 1){
        errorText += (",");
      }
    }
    return errorText;
  }

/**
   * @function
   * @description: This method is to TBD
   */
  onSubmit(value: string) {
    if (this.isReadyForSubmit) {
      this.submitted = true;
      this.thermalCyclingForm.reset();
      document.getElementById('thermalCreatedBy').focus();
      this.isReadyForSubmit = false;
    }
  }

  setPrinter(){
    this.selectedPrinter = this.carrierStateDetails.printer;
  }

}
